export * from './dashboard.component';
export * from './dashboard.route';
export * from './dashboard.module';



// WEBPACK FOOTER //
// ./src/main/webapp/app/dashboard/index.ts